export default __webpack_public_path__ + "static/media/signin.6a261026.jpg";